<template>
  <div>
    <canvas
      ref="canvas"
      style="position: absolute; pointer-events: none;"
    >
    </canvas>
  </div>
</template>

<script>
import { usePodLabelStore } from '@/stores/PodLabelStore.js';
import { usePlayerStore } from '@/stores/PlayerStore.js';

export default {
  name: "AWSTextLayer",
  data: function() {
    return {
      width: 0,
      height: 0,

      videoObserver: null,
      oldParent: null,
    }
  },
  mounted: function() {
    this.videoObserver = new ResizeObserver(this.onVideoResize);
    this.videoObserver.observe(this.getVideoElement());

    this.oldParent = this.getCanvas().parentNode;
    let newParent = this.getVideoElement().parentNode;
    newParent.appendChild(this.$refs.canvas);
  },
  beforeUnmount: function() {
    this.videoObserver.disconnect();
    this.oldParent.appendChild(this.getCanvas());
    this.getCanvas().remove();
  },
  methods: {
    getCanvas: function() {
      return this.$refs.canvas;
    },
    getVideoElement: function() {
      return this.getCanvas().parentNode.parentNode.getElementsByTagName('video')[0];
    },
    onVideoResize: function(entries) {
      // console.log('on video resize', entries);
      if (!this.getCanvas()) {
        return;
      }

      this.getCanvas().width = entries[0].contentRect.width;
      this.getCanvas().height = entries[0].contentRect.height;

      this.width = entries[0].contentRect.width;
      this.height = entries[0].contentRect.height;

      this.drawObjects();
    },
    drawObjects: function() {
      let context = this.getCanvas().getContext("2d");

      const playerTime = this.playerCurrentTime;

      context.strokeStyle = "#3dabff";
      context.clearRect(0, 0, this.width, this.height);

      for (let label of this.filteredLabels) {
        // limit the duration to 1 sec.
        if (playerTime < label.start || playerTime > label.end || playerTime > (label.start + 1)) {
          continue;
        }

        for (const labelInstance of label.instances) {
          const start = labelInstance.Timestamp ? Math.round(labelInstance.Timestamp / 1000) : 0;

          // limit the duration to 1 sec.
          if (playerTime < start || playerTime > (start + 1)) {
            continue;
          }

          if (this.showingRectangles) {
            this.drawRectangle(context, labelInstance);
          }

          if (this.showingLabels) {
            this.drawTextLabel(context, label.content, labelInstance);
          }
        }
      }
    },
    drawRectangle: function(context, labelInstance) {
      let top = labelInstance.BoundingBox.Top * this.height;
      let left = labelInstance.BoundingBox.Left * this.width;
      let width = labelInstance.BoundingBox.Width * this.width;
      let height = labelInstance.BoundingBox.Height * this.height;

      context.beginPath();
      context.strokeStyle = "#3dabff";
      context.rect(left, top, width, height);
      context.stroke();
    },
    drawTextLabel: function(context, labelContent, labelInstance) {
      let top = labelInstance.BoundingBox.Top * this.height -2;
      let left = labelInstance.BoundingBox.Left * this.width;

      context.fillStyle = "#3dabff";
      context.fillText(labelContent, left, top);
    }
  },
  computed: {
    getMlLabels: function() {
      const podLabelStore = usePodLabelStore();
      const mlLabels = podLabelStore.getMlLabels;

      return mlLabels.filter((x) => {
        return (x.service === 'aws-detecting-text' && (Array.isArray(x.instances) && x.instances.length > 0));
      });
    },
    filteredByType: function() {
      const filterByType = this.getLayerOptions.filterByType ? this.getLayerOptions.filterByType : "lines";

      switch (filterByType) {
        case "lines": return this.getMlLabels.filter(x => x.type === "line");
        case "words": return this.getMlLabels.filter(x => x.type === "word");
        default: return this.getMlLabels;
      }
    },
    filteredByConfidence: function() {
      const confidenceLevel = this.getLayerOptions.confidenceLevel ? this.getLayerOptions.confidenceLevel : 90;
      return this.filteredByType.filter(x => x.confidence >= confidenceLevel);
    },
    filteredLabels: function() {
      return this.filteredByConfidence;
    },
    playerCurrentTime: function() {
      const playerStore = usePlayerStore();
      return playerStore.currentTime;
    },
    getLayerOptions: function() {
      const playerStore = usePlayerStore();
      return playerStore.getLayersOptions.AWSDETECTEDTEXT;
    },
    showingLabels: function() {
      if (typeof this.getLayerOptions.showLabelsOnLayer == 'boolean') {
        return this.getLayerOptions.showLabelsOnLayer;
      }

      return true; // default value
    },
    showingRectangles: function() {
      if (typeof this.getLayerOptions.showRectOnLayer == 'boolean') {
        return this.getLayerOptions.showRectOnLayer;
      }

      return true;  // default value
    }
  },
  watch: {
    playerCurrentTime: function() {
      this.drawObjects();
    },
    getLayerOptions: function() {
      this.$nextTick(() => {
        this.drawObjects();
      });
    }
  }
}
</script>

<style>

</style>
